<template>
    <div>
        <v-row align="center" class="mb-4">
            <v-col :cols="2">
                <date-picker
                    v-model="dateFrom"
                    :label="$t('date_from')"
                    :clearable="false"
                    density="compact"
                    outlined
                    hide-details
                />
            </v-col>
            <v-col :cols="2">
                <date-picker
                    v-model="dateTo"
                    :label="$t('date_to')"
                    :clearable="false"
                    density="compact"
                    outlined
                    hide-details
                />
            </v-col>
            <v-col :cols="2">
                <v-select
                    v-model="selectedCurrency"
                    :loading="isLoading"
                    :disabled="isLoading"
                    :items="currencyList"
                    density="compact"
                    hide-details
                />
            </v-col>
            <v-col>
                <v-btn color="primary" class="mr-4" @click="resetFilters">{{ t('reset') }}</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="load">
                    {{ t('search') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="isLoading"
            color="primary"
            density="compact"
            hide-default-footer
            class="elevation-1"
        />
    </div>
</template>

<script setup lang="ts">
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import {format, subDays} from 'date-fns'

    const app = useNuxtApp()
    const conf = useRuntimeConfig()
    const {t} = useI18n()

    const headers: ComputedRef<{title: string; key: string; align?: string}[]> = computed(() => {
        return [
            {title: t('currency'), key: 'currencyCode', align: 'start'},
            {title: t('rate'), key: 'rate', align: 'end'},
            {title: t('factor'), key: 'factor', align: 'end'},
            {title: t('user_name'), key: 'userName', align: 'center'},
            {title: t('date'), key: 'date', align: 'center'},
        ]
    })
    const currencyList: ComputedRef<any[]> = computed(() =>
        Object.values(conf.public.currency.available).filter(currency =>
            Object.keys(runtimeStore.exchangeRates).includes(currency)
        )
    )

    const isLoading = ref<boolean>(false)
    const selectedCurrency = ref<string>(conf.public.currency.default)
    const dateFrom = ref<string>(format(subDays(new Date(), 7), 'yyyy-MM-dd'))
    const dateTo = ref<string>(format(new Date(), 'yyyy-MM-dd'))
    const items = ref<any[]>([])

    onMounted(() => {
        load()
    })

    function resetFilters(): void {
        dateFrom.value = format(subDays(new Date(), 7), 'yyyy-MM-dd')
        dateTo.value = format(new Date(), 'yyyy-MM-dd')
        selectedCurrency.value = conf.public.currency.default
        load()
    }

    async function load(): Promise<void> {
        try {
            isLoading.value = true
            const {manualExchangeRates} = await app.$api.manualExchangeRatesHistory.get({
                currencyCode: selectedCurrency.value,
                dateTo: dateTo.value,
                dateFrom: dateFrom.value,
            })
            items.value = manualExchangeRates
        } catch (e) {
            console.error(e)
        } finally {
            isLoading.value = false
        }
    }
</script>
